const ChangeStatusIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3078_754)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7501 6.66666C15.7501 3.49102 13.1757 0.916656 10.0001 0.916656C6.82444 0.916656 4.25008 3.49102 4.25008 6.66666V9.16666C4.25008 9.58087 4.58587 9.91666 5.00008 9.91666C5.4143 9.91666 5.75008 9.58087 5.75008 9.16666V6.66666C5.75008 4.31945 7.65287 2.41666 10.0001 2.41666C12.3473 2.41666 14.2501 4.31945 14.2501 6.66666V7.356L13.0304 6.13633C12.7375 5.84343 12.2626 5.84343 11.9698 6.13633C11.6769 6.42922 11.6769 6.90409 11.9698 7.19699L14.4698 9.69699C14.6104 9.83764 14.8012 9.91666 15.0001 9.91666C15.199 9.91666 15.3898 9.83764 15.5304 9.69699L18.0304 7.19699C18.3233 6.90409 18.3233 6.42922 18.0304 6.13633C17.7375 5.84343 17.2626 5.84343 16.9698 6.13633L15.7501 7.356V6.66666ZM5.00008 12.4167C3.57335 12.4167 2.41675 13.5733 2.41675 15C2.41675 16.4267 3.57335 17.5833 5.00008 17.5833C6.42682 17.5833 7.58341 16.4267 7.58341 15C7.58341 13.5733 6.42682 12.4167 5.00008 12.4167ZM0.916748 15C0.916748 12.7448 2.74492 10.9167 5.00008 10.9167C7.25524 10.9167 9.08341 12.7448 9.08341 15C9.08341 17.2552 7.25524 19.0833 5.00008 19.0833C2.74492 19.0833 0.916748 17.2552 0.916748 15ZM12.4167 15C12.4167 13.5733 13.5733 12.4167 15.0001 12.4167C16.4268 12.4167 17.5834 13.5733 17.5834 15C17.5834 16.4267 16.4268 17.5833 15.0001 17.5833C13.5733 17.5833 12.4167 16.4267 12.4167 15ZM15.0001 10.9167C12.7449 10.9167 10.9167 12.7448 10.9167 15C10.9167 17.2552 12.7449 19.0833 15.0001 19.0833C17.2552 19.0833 19.0834 17.2552 19.0834 15C19.0834 12.7448 17.2552 10.9167 15.0001 10.9167Z"
        fill="#667085"
        className={pathClassName}
      />
    </g>
    <defs>
      <clipPath id="clip0_3078_754">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ChangeStatusIcon;
